import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 16px;\n  margin-left: 8px;\n  font-size: ', ';\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 16px;\n  margin-left: 8px;\n  font-size: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  &&&&& {\n    margin-bottom: 20px;\n    margin-left: 0px;\n  }\n'], ['\n  &&&&& {\n    margin-bottom: 20px;\n    margin-left: 0px;\n  }\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';

import DatePicker from '../DatePicker';
import injected from '../../../injected';
import TimeInput from '../../../TimeInput';
import Icon from '../../../Icon';
import Switch from '../../../Switch';
import RecurrencyDetails from './RecurrencyDetails';
import { styles, translations, utils } from 'gipsy-misc';

var LabelTextToggle = styled.span(_templateObject, styles.fonts.fontSizeXSmall);

var ShouldBlockInCalendar = styled.div(_templateObject2);

var When = function (_PureComponent) {
  _inherits(When, _PureComponent);

  function When() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, When);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = When.__proto__ || Object.getPrototypeOf(When)).call.apply(_ref, [this].concat(args))), _this), _this.togglePinDate = function (_ref2) {
      var paramName = _ref2.paramName,
          value = _ref2.value;

      _this.props.onChange({ paramName: paramName, value: value });
    }, _this.togglePinTime = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          pinTime = _this$props.pinTime;

      if (pinTime) {
        onChange({ paramName: 'pin.time', value: null });
      } else {
        onChange({
          paramName: 'pin.time',
          value: utils.datetime.defaultStartTime
        }, {
          blockInCalendar: true
        });
      }
    }, _this.toggleShouldBlockInCalendar = function () {
      var _this$props2 = _this.props,
          shouldBlockInCalendar = _this$props2.shouldBlockInCalendar,
          onChange = _this$props2.onChange;

      if (shouldBlockInCalendar) {
        onChange({ paramName: 'shouldBlockInCalendar', value: false });
      } else {
        onChange({
          paramName: 'shouldBlockInCalendar',
          value: true
        });
      }
    }, _this.isAssignedToSelf = function () {
      var to = _this.props.to;

      return !to || injected.user.id == utils.user.getKey(to);
    }, _this.onRecurrencyDetailsChange = function (value) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          recurrencyDetails = _this$props3.recurrencyDetails;

      if (recurrencyDetails) {
        if (value) {
          onChange({ paramName: 'recurrencyDetails', value: value, method: 'change' });
        } else {
          onChange({ paramName: 'recurrencyDetails', value: value, method: 'remove' });
        }
      } else {
        onChange({ paramName: 'recurrencyDetails', value: value, method: 'add' });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(When, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          shouldBlockInCalendar = _props.shouldBlockInCalendar,
          pinTime = _props.pinTime,
          pinDate = _props.pinDate,
          onChange = _props.onChange,
          label = _props.label,
          value = _props.value,
          mode = _props.mode,
          editMode = _props.editMode,
          recurrencyDetails = _props.recurrencyDetails,
          onEditModeChange = _props.onEditModeChange,
          shouldHideRecurring = _props.shouldHideRecurring,
          shouldHideBlockInCalendar = _props.shouldHideBlockInCalendar;


      var pinHour = moment(pinTime).hour();
      var pinMinute = moment(pinTime).minute();
      return React.createElement(
        DatePicker,
        _extends({ className: 'when-field', label: label, icon: 'CalendarEmpty' }, this.props),
        React.createElement(
          'div',
          { className: 'pin-day' },
          React.createElement(
            'div',
            null,
            React.createElement(Switch, {
              className: 'inline-middle',
              size: 'small',
              paramName: 'pin.date',
              onChange: this.togglePinDate,
              value: !!(pinTime || pinDate)
            }),
            React.createElement(
              LabelTextToggle,
              null,
              translations.taskPanel.when.pinToDate
            )
          ),
          React.createElement(Icon, { icon: 'Pin', className: 'pin-day-icon' })
        ),
        React.createElement(
          'div',
          { className: 'pin-time gp-layout gp-row gp-space-between' },
          React.createElement(
            'div',
            { className: 'field-label' },
            React.createElement(Icon, { icon: 'Clock', className: 'label-icon' }),
            pinTime ? React.createElement(
              'span',
              { onClick: this.togglePinTime, className: 'label-text' },
              translations.taskPanel.when.startTime
            ) : React.createElement(
              'span',
              { onClick: this.togglePinTime, className: 'label-text gp-underline' },
              translations.taskPanel.when.setStartTime
            )
          ),
          pinTime && React.createElement(
            'div',
            { className: 'value' },
            React.createElement(TimeInput, {
              showPeriod: true,
              format: '12h',
              paramName: 'pin.time',
              hour: pinHour,
              minute: pinMinute,
              onChange: onChange
            })
          )
        ),
        !shouldHideBlockInCalendar && this.isAssignedToSelf() && React.createElement(
          ShouldBlockInCalendar,
          null,
          React.createElement(Switch, {
            className: 'inline-middle',
            size: 'small',
            paramName: 'shouldBlockInCalendar',
            onChange: this.toggleShouldBlockInCalendar,
            value: !!shouldBlockInCalendar
          }),
          React.createElement(
            LabelTextToggle,
            null,
            translations.taskPanel.when.shouldBlockInCalendar
          )
        ),
        !shouldHideRecurring && React.createElement(RecurrencyDetails, {
          when: value,
          value: recurrencyDetails,
          onChange: this.onRecurrencyDetailsChange,
          readOnly: mode === 'edit' && recurrencyDetails && editMode === 'standard',
          onRequestRecurringEdit: function onRequestRecurringEdit() {
            return onEditModeChange('recurring');
          }
        })
      );
    }
  }]);

  return When;
}(PureComponent);

When.propTypes = {
  mode: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  pinTime: PropTypes.string,
  pinDate: PropTypes.string,
  shouldBlockInCalendar: PropTypes.bool,
  to: PropTypes.object,
  noPadding: PropTypes.bool,
  backgroundHover: PropTypes.string,
  shouldHideRecurring: PropTypes.bool,
  shouldHideBlockInCalendar: PropTypes.bool,
  showClose: PropTypes.bool
};
When.defaultProps = {
  showClose: true
};


export default When;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/index.js
// module id = 308
// module chunks = 0